<div class="container-fluid vh-100 text-center  overflow-auto">
  <main>
    <div class="text-center pb-5"><img src="../../../../assets/img/pointslogoFS.png" class="img-responsive logo" /></div>
    <div *ngIf="currentUser && currentUser.Token">
      <div><h1>{{currentUser.RegistrationNumber}}</h1></div>
      <div><h5>{{currentUser.CompanyName}}</h5></div>
    </div>
    <div class="layout-content w-100 text-center" style="z-index:1000;">

      <router-outlet></router-outlet>
    </div>
    <div *ngIf="IsMenuVisible()" class="text-center p-2"><i class="fa fa-home fa-2x pr-3" aria-hidden="true" (click)="home()" title="Powrót do strony głównej"></i><i class="fa fa-sign-out fa-2x" aria-hidden="true" (click)="logout()" title="Wyloguj"></i></div>
    <div *ngIf="IsTFAMenuVisible()" class="text-center p-2"><i class="fa fa-sign-out fa-2x" aria-hidden="true" (click)="logout()" title="Wyloguj"></i></div>
    <div>
      Point S Polska, ul. Młynarska 7, 01-205 Warszawa<a href="mailto: point-s@point-s.pl" class="ml-2">point-s@point-s.pl</a>
    </div>
  </main>
</div>

